import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class FacePressuresPressuresAtLevelModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (FacePressuresPressuresAtLevelModel._instance == null) FacePressuresPressuresAtLevelModel._instance = new FacePressuresPressuresAtLevelModel(authManager);
        return FacePressuresPressuresAtLevelModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'face-pressures/face-pressures-pressures-at-levels');

        this.entityName = 'face-pressures.FacePressuresPressuresAtLevel';
        this.privileges = {
            create: [["#admin"]],
            read: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"],["readGeotechData"]],
            update: [["#admin"]],
            delete: [["#admin"]],
        };

        this.label = 'J S Pressure Result';
        this.setLabel = 'J S Pressure Results';

        this.browser = {
            name: 'default-face-pressures-facepressurespressuresatlevel-browser',
            moduleName: 'default-face-pressures-facepressurespressuresatlevel-browser',
            moduleTitle: 'J S Pressure Results',
            moduleStateSlotName: 'default-face-pressures-facepressurespressuresatlevel-browser',
        };

        this.editor = {
            name: 'default-face-pressures-facepressurespressuresatlevel-editor',
            moduleName: 'default-face-pressures-facepressurespressuresatlevel-editor',
            moduleTitle: 'J S Pressure Result',
            moduleStateSlotName: 'default-face-pressures-facepressurespressuresatlevel-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'uid',
                type: 'string',
                persistent: true,
                label: 'Unique ID',
                required: true,
                readOnly: true,
            },
            {
                name: 'calculationId',
                type: 'FacePressuresCalculation',
                persistent: true,
                label: 'Calculation',
            },
            {
                name: 'facePressuresModelIntervalId',
                type: 'FacePressuresModelInterval',
                persistent: true,
            },
            {
                name: 'modelIntervalId',
                type: 'ModelInterval',
                persistent: false,
                label: 'Model Interval',
                description: 'reference to particular ps model interval',
                readOnly: true,
            },
            {
                name: 'tbmBoundaryId',
                type: 'GeoObjectTbmBoundary',
                persistent: true,
                label: 'Tbm Level',
            },
            {
                name: 'levelAboveTbmAxis',
                type: 'float',
                persistent: false,
                unit: 'm',
                label: 'Level Above Tbm Axis',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'elevation',
                type: 'float',
                persistent: false,
                unit: 'masl',
                label: 'Elevation',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'objectTbmId',
                type: 'GeoObjectTbm',
                persistent: false,
                label: 'Object Tbm',
                readOnly: true,
            },
            {
                name: 'tbmAxisElevation',
                type: 'float',
                persistent: false,
                unit: 'masl',
                label: 'Tbm Axis Elevation',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'requiredMinimumSupportForceAtTunnelAxisFaxis1',
                type: 'float',
                persistent: true,
                unit: 'kN',
                label: 'Required Minimum Support Force At Tunnel Axis Faxis 1',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'requiredMinimumSupportPressureP1',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                label: 'Required Minimum Support Pressure P 1',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'totalMinimumVerticalStressAtTunnelCrownPcrown1',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                label: 'Total Minimum Vertical Stress At Tunnel Crown Pcrown 1',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'tunnelFaceRequiredSupportWaterForceInclSafetyCoefWcis',
                type: 'float',
                persistent: true,
                unit: 'kN',
                label: 'Tunnel Face Required Support Water Force Incl Safety Coef Wcis',
                description: 'Wre2',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'tunnelFaceRequiredSupportEarthForceInclSafetyCoefEmaxcis',
                type: 'float',
                persistent: true,
                unit: 'kN',
                label: 'Tunnel Face Required Support Earth Force Incl Safety Coef Emaxcis',
                description: 'Ere2Critical',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'requiredMinimumSupportForceAtTunnelAxisInclSafetyCoefFaxis2S',
                type: 'float',
                persistent: true,
                unit: 'kN',
                label: 'Required Minimum Support Force At Tunnel Axis Incl Safety Coef Faxis 2 S',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'requiredMinimumSupportPressureInclSafetyCoefP2S',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                label: 'Required Minimum Support Pressure Incl Safety Coef P 2 S',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'maximumAllowableSupportPressureInclSafetyCoefPmax2S',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                label: 'Maximum Allowable Support Pressure Incl Safety Coef Pmax 2 S',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'requiredMinimumSupportPressureInclSafetyCoefPrDevP3Sp',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                label: 'Required Minimum Support Pressure Incl Safety Coef Pr Dev P 3 Sp',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'maximumAllowableSupportPressureInclSafetyCoefPrDevPmax3Sp',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                label: 'Maximum Allowable Support Pressure Incl Safety Coef Pr Dev Pmax 3 Sp',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'waterPressurePwater',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                label: 'Water Pressure Pwater',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'finalRequiredMinimumSupportPressureInclSafetyCoefPrDevP4Spf',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                label: 'Final Required Minimum Support Pressure Incl Safety Coef Pr Dev P 4 Spf',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
        ];

    }

}
